import React from 'react';
import './styles.scss';
import { Typography } from 'Components/atoms';
import { LogicBadge } from 'Components/atoms/LogicBadge';
import { CondEntry, GroupNode } from 'Core-utils/types/rules.types';
import { condSummaryText } from 'Core-utils/helpers/ruleBuilderHelpers';

export interface SummaryTreeNodeProps {
    node: CondEntry | GroupNode;
}

const SummaryTreeNode = ({ node }: SummaryTreeNodeProps) => {
    if (node.kind === 'cond') {
        return (
            <div className="rb-summary-tree__cond">
                <span className="rb-summary-tree__bullet" />
                <Typography variant="caption1" color="text-high-emphasis" className="mb-0" style={{ fontSize: 12, lineHeight: 1.4 }}>
                    {condSummaryText(node)}
                </Typography>
            </div>
        );
    }

    return (
        <div className="rb-summary-tree__group">
            <div className="rb-summary-tree__group-badge">
                <LogicBadge logic={node.logic} />
            </div>
            <div className="rb-summary-tree__group-children">
                {node.children.map((child) => (
                    <SummaryTreeNode key={child.id} node={child} />
                ))}
            </div>
        </div>
    );
};

export default SummaryTreeNode;
